import { render } from "./BurgerMenuIcon.vue?vue&type=template&id=a38e89ec&scoped=true"
import script from "./BurgerMenuIcon.vue?vue&type=script&lang=js"
export * from "./BurgerMenuIcon.vue?vue&type=script&lang=js"

import "./BurgerMenuIcon.vue?vue&type=style&index=0&id=a38e89ec&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a38e89ec"]])

export default __exports__